import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import SubmitPill from '../ButtonPill/SubmitPill';
import { showModal, modalBack, hideModal } from 'legacy/actions/modalActions';

interface ContactFormSubmitProps {
  buttonText: string;
  loading?: boolean;
  errorContent?: string;
  errorOpen?: boolean;
  disabled?: boolean;
  type?: 'primary' | 'secondary' | 'plain';
  // Redux action creators
  showModal: typeof showModal;
  modalBack: typeof modalBack;
  hideModal: typeof hideModal;
}

const ContactFormSubmit = ({
  buttonText,
  loading,
  errorContent,
  errorOpen,
  disabled,
  type,
  showModal,
  modalBack,
  hideModal
}: ContactFormSubmitProps) => {
  useEffect(() => {
    if (!loading && errorOpen && errorContent) {
      showModal('ALERT', {
        message: errorContent,
        actionText: 'Go back',
        onSuccess: modalBack,
        onBack: hideModal,
        back_img: 'xBlock'
      });
    }
  }, [errorOpen, errorContent, loading]);

  return (
    <SubmitPill
      loading={loading}
      disabled={disabled}
      primary={!type || type === 'primary'}
      secondary={type === 'secondary'}
      plain={type === 'plain'}
      type="submit"
      onClick={() => {}}
    >
      {buttonText}
    </SubmitPill>
  );
};

export default connect(null, { showModal, modalBack, hideModal })(
  ContactFormSubmit
);
